<template lang="html">
  <div class="helpus">
    <v-row justify=center>
      <v-col cols="12" md="8">
        <nav class="componentSelectNav" v-if="animalsNeedHelp.length>0">
          <router-link
            tag="span"
            class="navitem"
            :to="{path:'/helpus', query:{selectedComp: 'HelpInfo'}}"
            :class="selectedComp=='HelpInfo' ? 'navitem-active' : ''"
            >Információk az adományozáshoz</router-link>
          <span class="divider">|</span>
          <router-link
            tag="span"
            class="navitem"
            :to="{path:'/helpus', query:{selectedComp: 'Surgos'}}"
            :class="selectedComp=='Surgos' ? 'navitem-active' : ''"
            >Sürgős segítségre van szükségük!</router-link>
          <span class="divider">|</span>
          <router-link
            tag="span"
            class="navitem"
            :to="{path:'/helpus', query:{selectedComp: 'Koltsegvetes'}}"
            :class="selectedComp=='Koltsegvetes' ? 'navitem-active' : ''"
            >Költségvetésünk</router-link>
        </nav>
      </v-col>
    </v-row>

    <component :is="selectedComp" />
  </div>
</template>

<script>
import HelpInfo from '@/components/Help/HelpInfo.vue'
import Surgos from '@/components/Help/Surgos.vue'
import Koltsegvetes from '@/components/Help/Koltsegvetes.vue'

export default {
  data(){
    return {
      selectedComp: 'Surgos',
      animalsNeedHelp: this.$store.getters.allAnimals.filter(a=>a.colorcode==='pink')
    }
  },
  components:{
    HelpInfo,
    Surgos,
    Koltsegvetes
  },
  mounted(){
    this.selectedComp = this.$route.query.selectedComp ?  this.$route.query.selectedComp : 'HelpInfo';
  },
  watch:{
    '$route'(to,from){
      this.selectedComp = this.$route.query.selectedComp ?  this.$route.query.selectedComp : 'HelpInfo';
    }
  }
}
</script>

<style lang="scss" scoped>
.helpus{
  width: 95%;
  margin: 0 auto;
  text-align: center;
}



</style>
